import DatabaseManagerStore from 'views/admin/DatabaseManager/DatabaseManagerStore';
import { RootStore } from '@intrasync/stores';
import { RouteType } from 'types/RouteType';

const databaseManagerRoute: RouteType = {
  name: 'Database Manager',
  path: '/database-manager/:servicePath',
  defaultParams: { servicePath: 'activate-user' },
  layout: '/admin',
  viewportCard: {
    header: {
      title: 'Database Manager',
      enableRefreshButton: true,
      enableBackButton: true,
      color: 'primary',
      component: () => import('./DatabaseManager.Header'),
    },
    body: {
      component: () => import('./DatabaseManager.Body'),
      grayBackground: false,
    },
  },
  dialogs: [
    {
      name: 'EntityViewerDialog',
      title: 'Entity Viewer',
      component: () => import('./DatabaseManager.EntityDialog'),
    },
  ],
  group: 'Admin',
  requiresAuth: true,
  requiresAdmin: true,
  requiresPermission: false,
  enableAutoFind: false,
  channels: [':servicePath'],
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const databaseManagerStore =
      rootStore.databaseManagerStore as DatabaseManagerStore;
    databaseManagerStore.findServiceStores();
    return true;
  },
};

export default databaseManagerRoute;
